import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';

export interface CapteurPosition {
  nom: string;
  france_metropolitaine: boolean;
  departement: string | null;
  latitude: number;
  longitude: number;
}

export interface CapteurPositionsResponse {
  items: CapteurPosition[];
  count: number;
}

@Injectable({
  providedIn: 'root'
})
export class CapteurExportService {
  private readonly baseUrl = `${environment.apiBaseUrl}/api/capteurs`;

  constructor(private readonly http: HttpClient) {}

  async getCapteurPositions(): Promise<CapteurPositionsResponse> {
    return firstValueFrom(
      this.http.get<CapteurPositionsResponse>(`${this.baseUrl}/positions/list`)
    );
  }

  async exportToExcel(): Promise<void> {
    try {
      const response = await this.getCapteurPositions();
      const items = response.items || [];

      // Créer le workbook avec SheetJS
      const data = items.map(item => ({
        'Nom': item.nom,
        'France métropolitaine': item.france_metropolitaine ? 'Oui' : 'Non',
        'Département': item.departement || '',
        'Latitude': item.latitude,
        'Longitude': item.longitude,
        'Position GPS': `${item.latitude}, ${item.longitude}`
      }));

      // Utiliser SheetJS pour générer l'Excel
      const XLSX = await import('xlsx');
      const ws = XLSX.utils.json_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Positions GPS');
      
      // Ajuster la largeur des colonnes
      ws['!cols'] = [
        { wch: 20 },  // Nom
        { wch: 20 },  // France métropolitaine
        { wch: 15 },  // Département
        { wch: 15 },  // Latitude
        { wch: 15 },  // Longitude
        { wch: 25 }   // Position GPS
      ];

      // Télécharger le fichier
      const filename = `capteurs_positions_${new Date().toISOString().split('T')[0]}.xlsx`;
      XLSX.writeFile(wb, filename);
    } catch (error) {
      console.error('Erreur lors de l\'export Excel:', error);
      throw error;
    }
  }
}
